import axios from 'axios'
import jmespath from 'jmespath'

const maskedURL = function (url) {
  return url.replace(/(\.com\/..)[^/]+(..\/)/, '$1..$2')
    .replace(/(\/au-..)[^/]+(..\/)/, '$1..$2')
}

const filterItems = function (source, name) {
  console.log(`getting data for ${name} from ${source.name}`)
  const url = source.url()
  return axios.get(url).then(function (response) {
    let result
    try {
      result = jmespath.search(response.data, source.jmespath)
    } catch (e) {
      const errorobj = {
        error: e + '',
        name: source.name,
        url: maskedURL(url),
        data: response.data,
        jmespath: source.jmespath
      }
      console.error(errorobj)
      result = [ { 'headline': source.errorString,
        urn: 'undefined',
        'article_html': JSON.stringify(errorobj) }]
    }
    return result
  }, function (e) {
    let result
    const errorobj = {
      error: e + '',
      name: source.name,
      url: maskedURL(url)
    }
    console.error(errorobj)
    result = [ { 'headline': source.errorString,
      urn: 'undefined',
      'article_html': JSON.stringify(errorobj) }]
    return result
  })
}

const listItems = function (sourceList, name) {
  let allItems = []
  sourceList.forEach(function (source) {
    if (source.enabled) {
      allItems.push(filterItems(source, name))
    }
  })
  return Promise.all(allItems)
}

const feedTicker = function (config) {
  if (typeof config.ticker === 'undefined') {
    console.log('No ticker configured')
    return new Promise(function () { return [] })
  } else {
    return listItems(config.ticker, 'ticker')
  }
}

const feedSlides = function (config) {
  if (typeof config.slides === 'undefined') {
    console.log('No slides configured.')
    return new Promise(function () { return [] })
  } else {
    return listItems(config.slides, 'slides')
  }
}

const versionInfo = function () {
  return axios.get('git.json' + '?' + Math.floor(new Date())).then(function (response) {
    return response.data
  }, function (error) {
    console.error(error)
    return Error(error)
  })
}

export default {
  slides: feedSlides,
  ticker: feedTicker,
  versionInfo: versionInfo
}
